export const userIsLogin = state => state.user.isLogin
export const userToken = state => state.user.token
export const userInfo = state => state.user.userInfo
export const userLocations = state => state.user.userLocations
export const userCurrentLocation = state => state.user.selectedLocation

export const pdftToView = state => state.user.base64Pdf
